export default __webpack_public_path__ + "static/media/Attention-orange.062a78b2.svg";